import React from 'react';
import css from './bfm.css';

const WestPacFeed = ({ userid }) => {

    return (
    <div className={[css.w600, css.fontSmall].join(' ')}>
        <div className={css.dFlex}>
            <div className={[css.flex1, css.pt20, css.muted].join(' ')}><i className="far fa-file fa-3x"></i></div> 
            <div className={css.flex6}>
                <p>To access your bank feed you’ll need to log in to Westpac Live Internet Banking.</p>
                <p>Once logged in Navigate to 'Services & Preferences' and select 'Services'. Then under Account services select Bank feeds. Select an account and choose Reckon for the third-party service provider.</p>
                <p>Paste the ID below into the Reckon User ID or Login field and click Connect Feed.</p>
                <p><strong>Primary ID: {userid}</strong></p>
            </div>
        </div> 
    </div>);
};

export default WestPacFeed;


// WEBPACK FOOTER //
// ./src/components/FeedManagment/WestPacFeed.js